import {useRuntimeConfig} from "#imports";

const allowedDomains = [
	'mastersportal',
	'bachelorsportal',
	'phdportal',
	'shortcoursesportal',
	'distancelearningportal',
];

export const useAPIBaseUrl = (): string | undefined => {
	if (import.meta.server) return undefined;

	const url = new URL(window.location.href);

	const getRuntimeConfig = useRuntimeConfig as typeof import("nuxt/app").useRuntimeConfig;
	const config = getRuntimeConfig();

	const apiDomainPrefix: string | undefined = config.public?.apiDomainPrefix as string | undefined;
	const apiDomainTLD = config.public?.apiDomainTLD as string | undefined;

	if(!apiDomainTLD || !apiDomainPrefix) return;

	const portalDomain = allowedDomains.find(domain => url.hostname.includes(domain));
	if(!portalDomain) return;

	return `https://${apiDomainPrefix}.${portalDomain}.${apiDomainTLD}`;
};